module.exports = __webpack_public_path__ + "static/media/df_icon_graphics.611469fa.svg";